module.exports = "https://coursera_assets.s3.amazonaws.com/images/54cd83898abab16a057f93ba7f3985d1.svg";